import { EventTypes } from "utilFunctions/Constants/Constants";
import { pushToDataLayerForGTM } from "utilFunctions/helperFunctions/analytics";
import SelectedAndUnselectdListing from "utilFunctions/shared/SelectedAndUnselectdListing";
interface EventTypeFiltersIC {
  todaySchedules: any;
  selectedItem: any;
  setselectedItem: any;
  setFilterState: any;
  filterState: any;
  selectedDate?: any;
  todayDate?: any;
}
const EventTypeFilters = ({
  selectedItem,
  setselectedItem,
  setFilterState,
}: // filterState,
EventTypeFiltersIC) => {
  return (
    <>
      <SelectedAndUnselectdListing
        data={EventTypes}
        selectedItem={selectedItem}
        onSelectHandler={(value: string) => {
          setselectedItem(value);
          localStorage.setItem("eventType", value);
          setFilterState((prevfilterState: any) => ({
            ...prevfilterState,
            eventType: value,
          }));
          pushToDataLayerForGTM({
            event: "ag_sc_view_classtype_my_schedule",
            CLASS_TYPE: value,
            CLASS_ID: value,
          });
        }}
        selectColor={"#008dc4"}
        unselectedColor={"#FFFFFF"}
        unselectedTextColor={"#757575"}
      />
    </>
  );
};
export default EventTypeFilters;
